import { HIRE_DEVELOPER_PROCESS_DATA, PROCESS_FEATURES_DATA } from "const/technology";
import Image from "next/image";
import { useState } from "react";
import Container from "../common/Container";
import Modal from "../common/Modal";
import HirepageButton from "./common/Button";

const WhyHireDeveloper = (properties) => {
  const { headLine, description, button } = properties.hireProcessSection;
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
  };
  return (
    <>
      <Container large>
        <div className="my-20 md:my-16 lg:mt-28 lg:mb-36 flex flex-col xl:flex-row">
          <div className="w-full xl:w-7/12">
            <h2 className="md:w-4/5 lg:w-11/12 text-4xl leading-tight md:text-4xl md:leading-snug lg:leading-tight lg:text-6xl font-medium text-black mr-0 mb-12 xl:mr-32">
              <span
                dangerouslySetInnerHTML={{
                  __html: headLine,
                }}
              ></span>
            </h2>
            <div
              className="text-base text-justify lg:pr-32 mb-8 [&>p]:mb-4 text-black [&_a]:text-blue-500"
              dangerouslySetInnerHTML={{ __html: description }}
            ></div>
            <div className="flex flex-wrap pt-10 md:pt-12 md:mr-20 lg:mr-32">
              {PROCESS_FEATURES_DATA.map((value) => (
                <div key={value.title} className="flex w-full md:w-6/12 pb-8">
                  <div>
                    <Image
                      alt="verified"
                      height={24}
                      quality={100}
                      src="/assets/common/round-true.webp"
                      width={24}
                    />
                  </div>
                  <div>
                    <p className="text-xl ml-6 mb-0">
                      <span>{value.title}</span>
                    </p>
                  </div>
                </div>
              ))}
            </div>
            <div className="pt-10">
              <HirepageButton
                button={button}
                buttonName="Book a 30 min Call Now"
                onClick={openModal}
              />
            </div>
          </div>
          <div className="w-full xl:w-5/12">
            <div className="py-12 px-4 mt-16 md:py-16 md:px-20 lg:mt-12 lg:py-20 lg:px-9 bg-primary-black rounded-3xl">
              {HIRE_DEVELOPER_PROCESS_DATA.map((items, index) => (
                <div className="gap-4 flex justify-between" key={items.id}>
                  <div className="flex flex-col items-center">
                    <Image
                      alt="profile"
                      height={61}
                      src={items.src}
                      width={61}
                    />
                    <div
                      className={`w-px bg-primary-yellow h-28 ${
                        HIRE_DEVELOPER_PROCESS_DATA.length - 1 === index
                          ? "hidden"
                          : "block"
                      }`}
                    ></div>
                  </div>
                  <div className="w-10/12 lg:w-4/5">
                    <h3 className="text-base md:text-xl text-white font-medium">
                      <span>
                        {index + 1}.&nbsp;{items.title}
                      </span>
                    </h3>
                    <p className="pb-4 md:pb-0 mb-0 md:mb-4 mt-2 text-justify md:text-start text-sm lg:text-base text-white/80">
                      <span>{items.description}</span>
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>
      <Modal isOpen={modalOpen} onClose={closeModal} />
    </>
  );
};
export default WhyHireDeveloper;
